// cacheUtils.js
// ─────────────────────────────────────────────────────────────────────────
// Utilidad compartida para cachear promesas por clave. Antes este mismo
// patrón (Map + has/get/set) vivía repetido en tres lugares distintos:
//   - Survey.js        → logoCache      (getLogoPromise)
//   - CreateSurvey.jsx → existsCache    (getSurveyExistsPromise)
//   - EditSurvey.jsx   → surveyCache    (getSurveyPromise / evictSurveyCache)

// ─────────────────────────────────────────────────────────────────────────

export function createPromiseCache() {
  const cache = new Map();

  return {
    /** Devuelve la promesa cacheada para `key`, o la crea con `factory()`. */
    getOrCreate(key, factory) {
      if (cache.has(key)) return cache.get(key);
      const promise = factory();
      cache.set(key, promise);
      return promise;
    },

    /** Elimina una entrada puntual (p. ej. para forzar un refetch). */
    delete(key) {
      cache.delete(key);
    },

    /** Elimina todas las claves que cumplan el predicado (p. ej. por prefijo). */
    evict(predicate) {
      for (const key of cache.keys()) {
        if (predicate(key)) cache.delete(key);
      }
    },

    /** Limpia todo el cache. */
    clear() {
      cache.clear();
    },
  };
}